import { render, staticRenderFns } from "./InvoiceTrendChart.vue?vue&type=template&id=136edb7c"
import script from "./InvoiceTrendChart.vue?vue&type=script&lang=js"
export * from "./InvoiceTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports